let appId: number | null = null;

let flatMenu = {};

let pathname = '';

export const getAppId = () => {
    return appId;
};

export const setAppId = (id: number) => {
    appId = id;
};

export const setVariablePathname = (path: string) => {
    pathname = path;
};

export const getVariablePathname = () => {
    return pathname;
};

export const setVariableFlatMenu = (menu: any) => {
    flatMenu = menu;
};

export const getVariableFlatMenu = () => {
    return flatMenu;
};
